import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import { AllStockTakeLotFieldsFragmentDoc } from '../../../_lib/__generated__/stock-take-lots-fragment.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HistoricStockTakeQueryVariables = Types.Exact<{
  stockTakeId: Types.Scalars['ID'];
  facilityId: Types.Scalars['ID'];
  input?: Types.InputMaybe<Types.StockTakeLotsInput>;
  options?: Types.InputMaybe<Types.StockTakeLotsOptions>;
}>;


export type HistoricStockTakeQuery = { readonly __typename?: 'Query', readonly stockTake?: { readonly __typename?: 'StockTake', readonly locationId: string, readonly finalisedAt?: string | null, readonly lots: { readonly __typename?: 'StockTakeLotsPage', readonly items: ReadonlyArray<{ readonly __typename?: 'StockTakeLotAddition', readonly id: string, readonly name: string, readonly expiryDate: string, readonly lastStockTakeAt?: string | null, readonly additionReviewQuantity: number, readonly additionQuantityDifference: number, readonly additionLot?: { readonly __typename?: 'StockTakePartialLot', readonly sku: { readonly __typename?: 'Sku', readonly id: string, readonly externalReferences: ReadonlyArray<{ readonly __typename?: 'SkuExternalReference', readonly origin: string }> } } | null } | { readonly __typename?: 'StockTakeLotUpdate', readonly id: string, readonly name: string, readonly reviewedQuantity?: number | null, readonly initialQuantity: number, readonly quantityDifference: number, readonly lastStockTakeAt?: string | null, readonly lot: { readonly __typename?: 'StockTakePartialLot', readonly expiryDate: string, readonly sku: { readonly __typename?: 'Sku', readonly id: string, readonly externalReferences: ReadonlyArray<{ readonly __typename?: 'SkuExternalReference', readonly origin: string }> } } }> }, readonly finalisedBy?: { readonly __typename?: 'User', readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null } | null, readonly aggregateInfo: { readonly __typename?: 'StockTakeAggregateInfo', readonly totalLotCount: number, readonly reviewedLotCount: number, readonly totalNewLotsAdded: number, readonly totalQuantityAdded: number, readonly totalQuantityRemoved: number } } | null };


export const HistoricStockTakeDocument = gql`
    query historicStockTake($stockTakeId: ID!, $facilityId: ID!, $input: StockTakeLotsInput, $options: StockTakeLotsOptions) {
  stockTake(input: {stockTakeId: $stockTakeId, facilityId: $facilityId}) {
    locationId
    finalisedAt
    lots(input: $input, options: $options) {
      items {
        ...AllStockTakeLotFields
      }
    }
    finalisedBy {
      person {
        firstname
        lastname
      }
    }
    aggregateInfo {
      totalLotCount
      reviewedLotCount
      totalNewLotsAdded
      totalQuantityAdded
      totalQuantityRemoved
    }
  }
}
    ${AllStockTakeLotFieldsFragmentDoc}`;

/**
 * __useHistoricStockTakeQuery__
 *
 * To run a query within a React component, call `useHistoricStockTakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricStockTakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricStockTakeQuery({
 *   variables: {
 *      stockTakeId: // value for 'stockTakeId'
 *      facilityId: // value for 'facilityId'
 *      input: // value for 'input'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useHistoricStockTakeQuery(baseOptions: Apollo.QueryHookOptions<HistoricStockTakeQuery, HistoricStockTakeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HistoricStockTakeQuery, HistoricStockTakeQueryVariables>(HistoricStockTakeDocument, options);
      }
export function useHistoricStockTakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HistoricStockTakeQuery, HistoricStockTakeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HistoricStockTakeQuery, HistoricStockTakeQueryVariables>(HistoricStockTakeDocument, options);
        }
export type HistoricStockTakeQueryHookResult = ReturnType<typeof useHistoricStockTakeQuery>;
export type HistoricStockTakeLazyQueryHookResult = ReturnType<typeof useHistoricStockTakeLazyQuery>;
export type HistoricStockTakeQueryResult = Apollo.QueryResult<HistoricStockTakeQuery, HistoricStockTakeQueryVariables>;